<script setup>
import { storeToRefs } from "pinia";
import { computed, ref } from "vue";

import PageBody from "@/components-ng/PageBody.vue";
import AlmConnectionsWidget from "@/components-ng/home/AlmConnectionsWidget.vue";
import AlmEventsWidget from "@/components-ng/home/AlmEventsWidget.vue";
import HomeHeader from "@/components-ng/home/HomeHeader.vue";
import OnboardHomePage from "@/components-ng/home/OnboardHomePage.vue";
import OnboardSuccessDialog from "@/components-ng/home/OnboardSuccessDialog.vue";
import SessionsWidget from "@/components-ng/home/SessionsWidget.vue";
import { isCloud } from "@/environment";
import { useAppStore } from "@/stores";

const store = useAppStore();
const { shouldOnboard, onPrem } = storeToRefs(store);

const canOnboard = computed(() => shouldOnboard.value && isCloud && !onPrem.value);

const lastOnboardResult = ref(null);
const successOpen = computed({
  get: () => !!lastOnboardResult.value,
  set: (v) => {
    if (!v) lastOnboardResult.value = null;
  },
});

function onOnboardSuccess(result) {
  lastOnboardResult.value = result;
  store.setShouldOnboard(false);
}
</script>

<template>
  <PageBody>
    <OnboardHomePage v-if="canOnboard" @success="onOnboardSuccess" />
    <div v-else class="home-stack">
      <HomeHeader />
      <div class="home-grid">
        <SessionsWidget />
        <AlmConnectionsWidget />
      </div>
      <AlmEventsWidget />
    </div>
    <OnboardSuccessDialog
      v-if="lastOnboardResult"
      v-model:open="successOpen"
      :session-id="lastOnboardResult.sessionId"
      :session-name="lastOnboardResult.sessionName"
      :team-id="lastOnboardResult.teamId"
    />
  </PageBody>
</template>

<style lang="scss" scoped>
.home-stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.home-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

@media (width < 880px) {
  .home-grid {
    grid-template-columns: 1fr;
  }
}
</style>
